
<div class="container m-auto flex flex-col h-screen justify-between ">

  <app-navbar></app-navbar>

  <div class="prose lg:prose-xl dark:prose-invert">

    <h1>Privacy Policy</h1>

    <p class="text-muted">Last Updated: October 10, 2023</p>

    <p>This Gameface app is part of a suite of teaching and learning tools provided by Groupwork Guru.</p>

    <p>
      At Groupwork Guru (hereafter referred to as "We" or "Our"), we are committed to protecting your privacy and providing you with safe and secure learning tools. This Privacy Statement explains how we collect, use, disclose, and safeguard your personal information when you use the Groupwork Guru website or any of the tools we provide (hereafter referred as the "Service"). Please take a moment to read this statement to understand how your data is handled.
    </p>

    <h2>1. Information Collection</h2>
    <p>
      When you interact with our Service, we may collect the following information from you, as described below:
    </p>

    <ol>
      <li>
        <strong>Information you provide</strong>

        <p>
          We collect information from you when you interact with the Service, e.g. volunteering for a task, answering a question, etc.
        </p>
      </li>

      <li>
        <strong>Information collected automatically</strong>

        <p>
          When you interact with our Service, we collect information that is automatically sent to us, this includes your IP address, any information that your browser sends to our Service as well as your activity in the Service
        </p>
      </li>

      <li>
        <strong>Information from third parties</strong>

        <p>
          When you allow us to collect your information from certain third parties. e.g. when you sign in using your institution's single sign on or LTI interface, your name and email is provided and collected by us to provide the Service.
        </p>
      </li>

    </ol>



    <h2>2. Information Use</h2>

    <p>
      We use the information we collect from you in a way that is consistent with this Privacy Policy.
    </p>

    <p>
      The information we collect is used only in the following manner:
    </p>
    <ul>
      <li>
        Provide customer support
      </li>
      <li>
        Provide, maintain, and improve the Service
      </li>
      <li>
        Provide any notifications you have chosen to receive
      </li>
      <li>
        Conduct research into how to improve teaching practices and learning outcomes
      </li>
    </ul>

    <h2>3. Information Disclosure</h2>

    We are not in the business of selling your information. We do not sell, rent or lease your information to any third parties. However, there are certain circumstances where your information may be disclosed to certain third parties.

    <ol>
      <li>
        <strong>With your consent:</strong>
        <p>
          We may disclose your information with your consent (i.e. if we specifically ask for your permission).
        </p>
      </li>
      <li>
        <strong>To your institution:</strong>
        <p>
          If you are a student in a course delivered by a particular institution, the instructors on behalf of the institution may access your information.
        </p>
      </li>
      <li>
        <strong>To research partners:</strong>
        <p>
          From time to time we may partner with academics and academic institutions to conduct research how to improve teaching practices and learning outcomes. Any such research will only be conducted with the approval of an independent ethics review board, and will either require your explicit consent (see point 1) or be limited to data that has been thoroughly anonymised.
        </p>
      </li>
      <li>
        <strong>Business transfer</strong>
        <p>
          If we or our business assets are acquired and user information among our assets transferred to or be acquired by a third party. You acknowledge that such transfers may occur, and that any parties who acquire us may continue to use your personal information according to this policy.
        </p>
      </li>
      <li>
        <strong>Legal obligation</strong>
        <p>
          We may disclose your information if required to do so by law, to comply with our legal obligations or to protect the safety and integrity of our Service.
        </p>
      </li>
    </ol>

    <h2>
      4. Information Security
    </h2>
    <p>
      We take security seriously and use industry standard practices to protect personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification. We regularly review our information collection, storage and processing practices.
    </p>

    <h2>
      5. Student Data and FERPA
    </h2>
    <p>
      Whilst using our services you may use personally identifiable Student Data that in the USA is protected as defined in the Family Educational Rights and Privacy Act ("FERPA"), 20 U.S.C. § 1232(g). We agree to treat Student Data as confidential and not to share it with third parties other than as described herein.
    </p>
    <p>
      You authorize us to access and process Student Data solely for the purposes of providing the Service, as an outsourced institutional function pursuant to FERPA 34 CFR Part 99.31(a)(1). The instruction staff or institution owns right, title and interest to all Student Data you provide or otherwise make available to us, and Ed does not own, control or license such Student Data, except so as to provide the Service described herein. You acknowledge and agree that, as between the parties, you are solely responsible for any and all Student Data, whether provided by instruction staff, Student, institution or any other third party.
    </p>
    <p>
      We do not share your personal information with third parties, except where required by law, to protect our own rights, or to provide a service to you. We only retain personal information for as long as necessary to provide you with a service.
    </p>

    <h2>
      6. National Privacy Principles and Privacy Act
    </h2>
    <p>
      We adhere to the National Privacy Principles of the Commonwealth of Australia, the Privacy Amendment (Notifiable Data Breaches) Act 2017, Privacy Amendment 2000 (Private Sector) and the Privacy Act 1988 (Privacy Act) of Australia, and the New Zealand Privacy Act 1993 and Privacy Bill 2019, which regulate handling of personal information and sensitive information.
    </p>

    <h2>
      7. Other Privacy Legislation
    </h2>
    <p>
      We will adhere to applicable privacy law, statutes, regulations and orders of any official government body with jurisdiction over our company and the academic institution. This includes state and federal law in the United States, provincial and federal law in Canada, English and UK law, and EU law.
    </p>

    <h2>
      8. Cookies and related technologies
    </h2>
    <p>
      We use cookies and local storage objects referred to herein collectively as "cookies" and other related approaches to collect information about your use of our website and to provide you the service.
    </p>
    <p>
      We only use cookies that are essential for your use of the website, in particular enabling you to access parts of our service that require authentication.
    </p>

    <h2>
      9. Children
    </h2>
    <p>
      Our services are for users over the age of 13. We do not knowingly collect or store personal information from children (visitors under the age of 13). If you are under the age of 13, you are ineligible to use the Service. If you believe your child has provided us with personal information, we encourage you to contact us immediately, and we will promptly remove such information from our Service.
    </p>

    <h2>
      10. Changes to our Privacy Policy
    </h2>
    <p>
      We reserve the right to update or modify this Privacy Policy at any time and from time to time without prior notice. Please review this policy periodically, and especially before you provide any information. This Privacy Policy was last updated on the date indicated above. Your continued use of the Service after any changes or revisions to this Privacy Policy shall indicate your agreement with the terms of such revised Privacy Policy.
    </p>

    <h2>
      11. Contact
    </h2>

    <p>
      For any questions or concerns please contact <a href="mailto:info@groupworkguru.com">info&#64;groupworkguru.com</a>
    </p>
  </div>

  <app-footer></app-footer>
</div>
